import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates';
import NoData from '@webparts/components/common/NoData.vue';
import { GroupShortcutModel } from './ExternalShortcutWebpart';
import FormGroup from '@appbase/components/forms/FormGroup.vue';
import { mapGetters } from 'vuex'

import api from '@webparts/api';
import * as accouttypes from '@account/store/types'
import * as urlHelper from '@appbase/util/url-helper'
import { buildStyle } from "@appbase/util/popup-helper"

import SubtleRSA from '@appbase/util/subtle-rsa'
import { replaceUserKeyword } from '@appbase/util';

@Component({
    components: {
        ModalLayout,
        NoData,
        FormGroup
    },
    computed: mapGetters({
        current: accouttypes.CURRENT,
    }),
})
export default class ShortcutMoreModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart
    @Prop({ type: Boolean }) useCategory!: boolean

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    categoryList: kyobobook.ShortcutCategory[] = [];
    shortcutList: kyobobook.Shortcut[] = [];

    displayModel: GroupShortcutModel[] = [];
    
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    async handleClick(link: kyobobook.Shortcut) {
        if(link.shortcutId) this.addClickCount(link.shortcutId);

        var url = link.linkUrl;
        var features = ''
        var target = '_blank'

        if((/\$\{[A-Za-z0-9]+\}/g).test(url)){
            let urlReplaced = replaceUserKeyword(url, this.current.user);
            url = urlReplaced
        }
        
        if (url.includes('api/processToken')) {
            var _url = new URL(url)

            var searchParams = _url.searchParams

            var redirect = searchParams.get("redirectUrl") ?? "_blank"
            _url.searchParams.delete("redirectUrl")

            var search: string[] = []
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
            if (_url.search !== '') {
                var _search = _url.search.slice(1).split('&')
                search = search.concat(_search)
            }
            var params = this.getParams(search)

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
                : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
                
            target = redirect
        } else if(url.includes('page/hmac')) {
            var _url = new URL(url);

            var searchParams = _url.searchParams;

            var redirect = searchParams.get("redirectUrl") ?? "";
            redirect = decodeURIComponent(redirect);
            _url.searchParams.delete("redirectUrl");

            const token = `personCode=${this.current.user.personCode}&actionUrl=${redirect}`;

            const rsa = new SubtleRSA(this.current.key);
            await rsa.initialize();
            const encrypted = await rsa.encrypt(token);

            url = `${window.location.origin}/cm/Kyobobook/redirect/page/hmac?token=${encodeURIComponent(encrypted)}`;
        } else if (url.includes('page/EmployeeMall')) {
            var _url = new URL(url);
            var searchParams = _url.searchParams;

            var redirect = searchParams.get("redirectUrl") ?? "";
            redirect = decodeURIComponent(redirect);
            _url.searchParams.delete("redirectUrl");

            const token = `personCode=${this.current.user.personCode}`;

            const rsa = new SubtleRSA(this.current.key);
            await rsa.initialize();
            const encrypted = await rsa.encrypt(token);

            url = `${window.location.origin}/cm/Kyobobook/redirect/page/EmployeeMall?token=${encodeURIComponent(encrypted)}`;
        } else if(url.includes('attendance')) {
            // 모듈이 분리된 근태관리 예외 처리
            var redirect = '/main';

            var search: string[] = [];
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`);

            var params = this.getParams(search);

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key, 'attendance')
                : `${window.location.origin}/attendance${redirect}`;
            
            target = redirect
        }

        if(link.isPopup) features = buildStyle({ width: 900, height: 800 })

        window.open(url, target, features);      
    }

    getParams(search: string[]) {
        var res = ''

        for (var i = 0; i < search.length; i++) {
            res += `&${search[i]}`
        }

        if (res.startsWith('&'))
            res = res.slice(1)

        return res
    }

    addClickCount(shortcutId: number) {
        if(this.webpart.id) {
            api.kyobobook.addClickCount(this.webpart.id, shortcutId);
        }
    }

    load() {
        if (this.webpart.id) {
            Promise.all([
                api.kyobobook.getShortcutCategoryList(this.webpart.id!),
                api.kyobobook.getShortcutList(this.webpart.id!)
            ]).then(res => {
                this.categoryList = res[0];
                this.shortcutList = res[1];
    
                this.displayModel = this.categoryList.map(c => {
                    const displayModelItem: GroupShortcutModel = {
                        id: c.categoryId!,
                        displayName: c.title,
                        childs: []
                    }
    
                    const shortcuts = this.shortcutList.filter(s => s.categoryId == c.categoryId);
                    shortcuts.forEach(s => {
                        displayModelItem.childs.push(s);
                    });
    
                    return displayModelItem;
                });
            })
        }
    }

    getTitleSplit(title: string){
        return title.split('\n')
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
		this.load();
    }
}